import type { OperatingCostInvoiceLineItemV1Dto } from '@/openapi';

// All possible sources for invoice line items
export type InvoiceItemSuggestionSource = 'ai' | 'latest' | 'other';
export type InvoiceItemSource = 'actual' | 'previous' | InvoiceItemSuggestionSource;

export interface OperatingCostInvoiceLineItemSimple {
  id: string;
  version: number;
  areaDesignation: string;
  nameOnStatement: string;
  sfmPositionId: string;
  sfmPositionName: string;
  isFlatRate: boolean;
  totalAmount?: number;
  customerAmount?: number;
  totalArea?: number;
  customerArea?: number;
  status?: OperatingCostInvoiceLineItemV1Dto.status;
  invoiceItemSource?: InvoiceItemSource /* tracks source: actual | previous | ai | latest | other */;
}

export type OperatingCostInvoiceLineItemWithSource = OperatingCostInvoiceLineItemSimple & {
  invoiceItemSource: InvoiceItemSource;
};

// 🎯 Helper functions to distinguish between suggestions and actual items
/**
 * Determine if a line item is a suggestion (not yet added to the invoice).
 * Suggestions come from: AI, Latest Invoice import, or other existing invoices
 */
export function isSuggestion(source?: InvoiceItemSource): boolean {
  return source === 'ai' || source === 'latest' || source === 'other';
}

/**
 * Determine if a line item is an actual invoice line (permanent).
 * Actual items come from: current invoice (actual) or previous year (previous)
 */
export function isActualItem(source?: InvoiceItemSource): boolean {
  return source === 'ai';
}
